import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../../../../firebase'
import StateContext from '../../../../../StateContext'
import LiveFixturesByDate from './LiveFixturesByDate'

function FavoriteLeaguesLive({
    date,
    isLoading,
    setIsLoading,
    type,
    allFixtures,
}) {
    const appState = useContext(StateContext)

    const [leagues, setleagues] = useState([])
    const [error, setError] = useState(false)

    useEffect(() => {
        try {
            const favLeaguesRef = firestore
                .collection('users')
                .doc(appState.userId)
                .collection('favoritedLeaguesAPI')
            favLeaguesRef.onSnapshot(({ docs }) => {
                const leagues = docs.map((doc) => {
                    return { id: doc.id, ...doc.data() }
                })
                setleagues(leagues)
            })
        } catch (error) {
            setError('Kunne ikke laste ligaer')
        }
    }, [appState.userId])

    function filterFixturesLeague(allFixturesDate, leagueId) {
        const leagueFixtures = allFixturesDate.filter((league) => {
            return +league.league_id === +leagueId
        })
        return leagueFixtures
    }

    if (!leagues) return <React.Fragment></React.Fragment>

    return (
        <React.Fragment>
            {leagues?.length > 0 && (
                <div className="py-2">
                    <small>
                        <i className="fas fa-star text-warning"></i>{' '}
                        Favorittligaer
                    </small>
                </div>
            )}

            {leagues?.map((league, index) => {
                const leagueFixtures = filterFixturesLeague(
                    allFixtures,
                    league.league_id
                )

                return (
                    <LiveFixturesByDate
                        key={index}
                        type={type}
                        leagueId={league.league_id}
                        leagueLogo={league.league_logo}
                        leagueName={league.league_name}
                        date={date}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        leagueFixtures={leagueFixtures}
                    />
                )
            })}
        </React.Fragment>
    )
}
export default FavoriteLeaguesLive
